import $ from "jquery";

export const heroVenueMedia = () => {
  const video = $(".hero-venues-media video");
  const images = $(".hero-venues-media .banner");
  let currentImageIndex = 0;

  // Function to show the next image using arrow function
  const showNextImage = () => {
    // Hide all images initially
    images.css("opacity", 0);

    // Show the next image
    $(images[currentImageIndex]).css("opacity", 1);
    currentImageIndex = (currentImageIndex + 1) % images.length; // Loop back to the first image

    // Wait for some time before showing the next image
    setTimeout(showNextImage, 3000); // Change image every 3 seconds
  };

  // Check if a video exists
  if (video.length) {
    // If there are no images, loop the video instead of starting the slideshow
    if (images.length === 0) {
      video.on("ended", () => {
        video[0].play(); // Play the video again from the start
      });
    } else {
      // When the video ends, fade it out and then start showing images
      video.on("timeupdate", () => {
        // Check if the video is about to end (1 second before the end)
        if (video[0].duration - video[0].currentTime <= 1) {
          video.off("timeupdate"); // Remove the timeupdate event listener to prevent multiple triggers
          showNextImage(); // Start showing the next image immediately
          video.fadeOut(1000); // Then fade out the video over 1 second
        }
      });
    }
  } else {
    // If no video exists and there are images, start the slideshow immediately
    if (images.length > 0) {
      showNextImage();
    }
  }
};
